"use strict";

import { Application } from "../main/application.js";
import { Screen } from "../systems/core/screen.js";

export class Helper {
    static getPlatformValues(config) {
        if (config["x"] !== undefined || config["y"] !== undefined || typeof config == "number") {
            return config;
        }
    
        if (Application.main.device.isDesktop && config["desktop"] !== undefined) {
            return Helper.getOrientationValues(config["desktop"]);
        }
    
        if (Application.main.device.isTablet) {
            if (config["tablet"] !== undefined) {
                return Helper.getOrientationValues(config["tablet"]);
            } else if (config["mobile"] !== undefined) {
                return Helper.getOrientationValues(config["mobile"]);
            }
        }
    
        if (Application.main.device.isMobile && config["mobile"] !== undefined) {
            return Helper.getOrientationValues(config["mobile"]);
        }
    
        return Helper.getOrientationValues(config);
    }
    static getOrientationValues(config) {
        return config["portrait"] !== undefined ? config[Screen.main.orientation] : config;
    }
    
    static getURLParameter(sParam) {
        const sPageURL = window.location.search.substring(1);
        const sURLVariables = sPageURL.split("&");
        for (let i = 0; i < sURLVariables.length; i++) {
            let sParameterName = sURLVariables[i].split("=");
            if (sParameterName[0] == sParam) {
                return sParameterName[1];
            }
        }
    }
    
    static getExternalParameters() {
        let ext_params = {};
        let href = decodeURI(window.location.href);
        let searchParams = new URLSearchParams(href);
        for (let pair of searchParams.entries()) {
            if(pair[0].indexOf("ext_params") != -1) {
                let field = pair[0].substring(pair[0].lastIndexOf("[") + 1, pair[0].lastIndexOf("]") );
                ext_params[field] = pair[1];
            }
        }
        return ext_params;
    };
    
    static fileExists(url, callback) {
        // NEEDS IMPROVEMENT!
        const request = new XMLHttpRequest();
        request.onreadystatechange = function() {
            if (this.readyState !== this.DONE) return;
            callback?.(this.status === 200);
        }
        request.open("HEAD", url);
        request.send(null);
    }
    
    static sortContainer(container) {
        container.sortableChildren = true;
        container.children.forEach((item, index) => {
            item.zIndex = index;
        });
    }
    
    static sortNumber(a,b) {
        return a - b;
    }
    
    static lineCount(text) {
        let nLines = 0;
        for(let i = 0, n = text.length; i < n; i++) {
            if (text[i] === "\n") nLines++;
        }
        return nLines;
    }
    
    static hexToChar(str) {
        return str.replace(/&#([a-zA-Z0-9]+);/g, function(match, group1){
            return String.fromCharCode(parseInt("0" + group1));
        });
    }
    
    static rgbToHex(r, g, b) {
        if (r.r !== undefined) {
            return "0x" + ((1 << 24) + 
            (Math.floor(r.r * 255) << 16) + 
            (Math.floor(r.g * 255) << 8) + 
            Math.floor(r.b * 255)).toString(16).slice(1);
        }
    
        return "0x" + ((1 << 24) + 
        (Math.floor(r * 255) << 16) + 
        (Math.floor(g * 255) << 8) + 
        Math.floor(b * 255)).toString(16).slice(1);
    }
    static componentToHex(c) {
        let hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }
    
    static lerpColor(a,b,delta) { 
        var ah = parseInt(a.replace(/0x/g, ""), 16),
            ar = ah >> 16, ag = ah >> 8 & 0xff, ab = ah & 0xff,
            bh = parseInt(b.replace(/0x/g, ""), 16),
            br = bh >> 16, bg = bh >> 8 & 0xff, bb = bh & 0xff,
            rr = ar + delta * (br - ar),
            rg = ag + delta * (bg - ag),
            rb = ab + delta * (bb - ab);
    
        return "0x" + ((1 << 24) + (rr << 16) + (rg << 8) + rb | 0).toString(16).slice(1);
    }

    static hslToHex(h, s, l) {
        l /= 100;
        const a = s * Math.min(l, 1 - l) / 100;
        const f = n => {
            const k = (n + h / 30) % 12;
            const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
            return Math.round(255 * color).toString(16).padStart(2, "0");   // convert to Hex and prefix "0" if needed
        };
        return `0x${f(0)}${f(8)}${f(4)}`;
    }
    
    static outOfBounds(point,position,size,pivot = { x: 0.5, y: 0.5}) {
        if (point === undefined ||
            position === undefined ||
            size === undefined) return false;
    
        return point.x < position.x - size.width * pivot.x ||
            point.x > position.x + size.width * (1 - pivot.x) ||
            point.y < position.y - size.height * pivot.y ||
            point.y > position.y + size.height * (1 - pivot.y);
    }
}